import React, { useEffect, useState } from 'react'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Autocomplete,
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination
} from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'
import EditIcon from '@mui/icons-material/Edit'
import Tooltip from '@mui/material/Tooltip'
import { ProductService } from 'services/productService'
import { IErrorResponse, ISuccessResponse } from 'services/interfaces/common.interface'
import { showNotification, STATUS } from 'common/constant'
import InputLabelDownWithDropDown from 'components/InputlabeldownwithDropdown'
import ActionButton from 'components/ActionButton'
import ListingStatus from 'components/ListingStatus'
import ProductDetailsSlider from 'components/productDetailsSlidder'
import { IAddProductCatalog, IEditProductCatalog, IListingProduct } from 'services/interfaces/product.interface'
import InputField from 'components/InputField/InputField'

import 'rc-slider/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'

import './styles.scss'
import { useForm } from 'react-hook-form'
import SortIcon from 'components/SortIcon'
import { useHistory } from 'react-router-dom'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

type ALLProductprops = {
  products: []
}

type filterProductsForm = {
  name: string
  wholesale_price: string
  mrp: string
  erp_item_code: string
  sku: string
  ext_prod_id: string
  psn: string
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: 300
  },
  margin: {
    height: theme.spacing(3)
  },
  thumb: {
    background: '#ff632b',
    '&~&': {
      background: '#ff632b'
    }
  },
  mark: {
    background: 'black'
  },
  rail: {
    background: 'grey'
  },
  track: {
    background: '#ff632b !important'
  },
  valueLabel: {
    '&>*': {
      background: 'black'
    }
  }
}))

const ALLProductTable: React.FC<ALLProductprops> = ({ products }) => {
  const classes = useStyles()
  const history = useHistory();

  const { register, handleSubmit } = useForm({ mode: 'all' })

  const [product, setProducts] = useState<IListingProduct[]>([])
  const [pageCount, setPageCount] = useState<number>()
  const [RejectDialog, setRejectDialog] = React.useState<boolean>(false)
  const [rejectPimcode, setRejectPimcode] = useState<string>('')
  const [BlockDialog, setBlockDialog] = React.useState<boolean>(false)
  const [blockPimcode, setBlockPimcode] = useState<string>('')
  const [filterCategory, setFilterCategory] = useState<any>({})
  const [filterSku, setFilterSku] = useState<any>({})
  const [filterbrand, setFilterBrand] = useState<any>({})
  const [filterErpCode, setFilterErpCode] = useState<any>({})
  const [filterName, setFilterName] = useState<any>({})
  const [filterSelCode, setFilterSelCode] = useState<any>({})
  const [filterPsn, setFilterPsn] = useState<any>({})
  const [menu_text, setMenuText] = useState<string>('1')
  const [filterMrp, setFilterMrp] = React.useState<number[]>([0, 35000])
  const [filterPrice, setFilterPrice] = React.useState<number[]>([0, 35000])
  const [maxMrp, setMaxMrp] = useState<number>(0)
  const [maxPrice, setMaxPrice] = useState<number>(0)
  const [displayModal, setDisplayModal] = useState<boolean>(false)
  const [selectedItem, setSelectedItem] = useState<IListingProduct>()
  const [showEditConfirmation, setShowEditConfirmation] = useState<boolean>(false)
  const [showProductEditDialog, setShowProductEditDialog] = useState<boolean>(false)
  const [editableProduct, setEditableProduct] = useState<IListingProduct | undefined>(undefined)
  const [rejectReason, setRejectReason] = useState<string>("");
  
  const productService: ProductService = new ProductService()
  const IReason = ['High MRP Price', 'High Wholesale Price', 'Incorrect seller Product Id'];

  const multipleProductFilter = async (data: filterProductsForm | any, columnName?: string, sortType?: string) => {
    try {
      const Pimproducts: ISuccessResponse | IErrorResponse = (await productService.multipleSearchProduct(
        'all',
        1,
        data,
        columnName,
        sortType
      )) as ISuccessResponse
      const getpimproducts = Pimproducts
      setProducts(getpimproducts.data)
      setPageCount(getpimproducts.pagecount)
    } catch (error) {
      showNotification(STATUS.FAILURE, 'Unable to get Product informations')
    }
  }

  const handleProductFilter = () => {
    const data = {
      erp_item_code: filterErpCode?.erp_item_code ?? '',
      sku: filterSku?.sku ?? '',
      category: filterCategory?.category ?? '',
      brand: filterbrand?.brand ?? '',
      name: filterName?.name ?? '',
      ext_prod_id: filterSelCode?.ext_prod_id ?? '',
      psn: filterPsn?.psn ?? '',
      minPrice: filterPrice[0],
      maxPrice: filterPrice[1],
      minMrp: filterMrp[0],
      maxMrp: filterMrp[1]
    }
    multipleProductFilter(data)
  }

  /* To sort the table data based on column */
  const sortingFunctionalityHandler = (columnName: string, sortType: string) => {
    const data = {
      erp_item_code: filterErpCode?.erp_item_code ?? '',
      sku: filterSku?.sku ?? '',
      brand: filterbrand?.brand ?? '',
      category: filterCategory?.category ?? '',
      name: filterName?.name ?? '',
      ext_prod_id: filterSelCode?.ext_prod_id ?? '',
      psn: filterPsn?.psn ?? '',
      minPrice: filterPrice[0],
      maxPrice: filterPrice[1],
      minMrp: filterMrp[0],
      maxMrp: filterMrp[1]
    }
    multipleProductFilter(data, columnName, sortType)
  }

  const getSellerProducts = async (pageNO) => {
    try {
      const seller_products: ISuccessResponse | IErrorResponse = await productService.getSellerProducts('all', pageNO)
      const get_seller_products = seller_products as ISuccessResponse

      setProducts(get_seller_products.data)

      setPageCount(get_seller_products.pagecount)
    } catch (error) {
      showNotification(STATUS.FAILURE, 'Unable to get Product informations')
    }
  }

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    getSellerProducts(value)
  }

  const statusAPIHandler = async (productstatus: string, pimcode: string, reason?: string) => {
    try {
      if(!rejectReason.length && (productstatus === 'Rejected' || productstatus=== 'Blocked') ) {
        showNotification(STATUS.WARNING, 'Kindly select the  reason');

        return
      }

      const approveProduct: ISuccessResponse | IErrorResponse = await productService.approveProduct(
        productstatus,
        pimcode, 
        reason
      )

      if (approveProduct.status) {
        showNotification(STATUS.SUCCESS, `Product is ${productstatus} successfully`)
        getSellerProducts(1)
        setRejectReason("");
      }
    } catch (error) {
      showNotification(STATUS.FAILURE, 'Unable to approve Product ')
    }
  }

  const statusProductHandler = async (status: string, pimcode: string) => {
    if (status === 'Rejected') {
      setRejectDialog(true)
      setRejectPimcode(pimcode)
    } else if (status === 'Blocked') {
      setBlockDialog(true)
      setBlockPimcode(pimcode)
    } else {
      statusAPIHandler(status, pimcode);
    }

      
  }

  useEffect(() => {
    const maxPrice =
      products?.length > 0 ? Math.max(...products.map((item: IListingProduct) => item.wholesale_price)) : 0
    const maxMrp = products?.length > 0 ? Math.max(...products.map((item: IListingProduct) => item.mrp)) : 0

    setMaxPrice(maxPrice)
    setMaxMrp(maxMrp)
    setFilterMrp([0, maxMrp])
    setFilterPrice([0, maxPrice])
  }, [products])

  useEffect(() => {
    getSellerProducts(1)
  }, [])

  /* Edit product price details handler */
  const editProductConfirmationHandler = (): void => {
    setShowEditConfirmation(false)
    setShowProductEditDialog(true)
  }

  const productEditConfirmationHandler = (product: any) => {
    setShowEditConfirmation(true)
    setEditableProduct(product)
  }

  /* Edit Product Price handler */
  const editProductPriceHandler = async (data: IAddProductCatalog): Promise<void> => {
    try {
      const editProductdata: IEditProductCatalog = {
        seller_code: editableProduct?.seller_code as string,
        erp_item_code: editableProduct?.erp_item_code as string,
        mrp: Number(data?.mrp) as number,
        wholesale_price: Number(data.wholesale_price) as number,
        ext_prod_id: data.ext_product_id as string
      }

      /* Condition to avoid unwanted API calls when price is not modified */
      if (Number(data.wholesale_price) === editableProduct?.wholesale_price && Number(data.mrp) === editableProduct?.mrp) {
        showNotification(STATUS.WARNING, "Kindly update the price values to save");
  
        return
      }

      const editProductCatelogResult = await productService.editProductCatalog(editProductdata)

      if (editProductCatelogResult.status === STATUS.SUCCESS) {
        setShowProductEditDialog(false)
        history.push('/sellerLayout/ListedProducts/Pending')

        showNotification(STATUS.SUCCESS, 'Product Price updated Successfully')
        getSellerProducts(1)
      } else {
        showNotification(STATUS.FAILURE, 'Unable to edit product information')
      }
    } catch (error) {
      showNotification(STATUS.FAILURE, 'Unable to edit product information')
    }
  }

  return (
    <div className="Inventory-table-body">
      <div className="filter-head ">
        <div className="filter-item">
          <FontAwesomeIcon className="filter-icon" icon={faFilter as IconProp} />
        </div>
        <div className="filter-item">
          <FormControl fullWidth>
            <Autocomplete
              classes={classes}
              getOptionLabel={(option: IListingProduct) => option.name || ''}
              id="combo-box-demo"
              options={products || []}
              renderInput={(params) => <TextField {...params} label="Product Name" size="small" variant="outlined" />}
              style={{ width: 230 }}
              value={filterName}
              size="small"
              onChange={(e, val) => setFilterName(val)}
            />
          </FormControl>
        </div>

        <div className="filter-item">
          <Autocomplete
            size="small"
            classes={classes}
            getOptionLabel={(option: IListingProduct) => option.category || ''}
            id="combo-box-demo"
            options={
              products?.filter(
                (v: IListingProduct, i, a) => a.findIndex((t: IListingProduct) => t.category === v.category) === i
              ) || []
            }
            renderInput={(params) => <TextField {...params} label="Category" size="small" variant="outlined" />}
            style={{ width: 160 }}
            value={filterCategory}
            onChange={(e, value) => setFilterCategory(value)}
          />
        </div>

        <div className="filter-item">
          <FormControl fullWidth>
            <Autocomplete
              classes={classes}
              getOptionLabel={(option: IListingProduct) => option.sku || ''}
              id="combo-box-demo"
              options={products || []}
              renderInput={(params) => <TextField {...params} label="SKU" size="small" variant="outlined" />}
              style={{ width: 200 }}
              value={filterSku}
              onChange={(e, val) => setFilterSku(val)}
            />
          </FormControl>
        </div>

        <div className="filter-item">
          <FormControl fullWidth>
            <Autocomplete
              classes={classes}
              getOptionLabel={(option: IListingProduct) => option.brand || ''}
              id="combo-box-demo"
              options={
                products?.filter(
                  (v: IListingProduct, i, a) => a.findIndex((t: IListingProduct) => t.brand === v.brand) === i
                ) || []
              }
              renderInput={(params) => <TextField {...params} label="Brand" size="small" variant="outlined" />}
              style={{ width: 200 }}
              value={filterbrand}
              onChange={(e, val) => setFilterBrand(val)}
            />
          </FormControl>
        </div>

        <div className="filter-item">
          <FormControl fullWidth>
            <Autocomplete
              classes={classes}
              getOptionLabel={(option: IListingProduct) => option.erp_item_code || ''}
              id="combo-box-demo"
              options={products || []}
              renderInput={(params) => <TextField {...params} label="Poorvika Code" size="small" variant="outlined" />}
              style={{ width: 160 }}
              value={filterErpCode}
              onChange={(e, value) => setFilterErpCode(value)}
            />
          </FormControl>
        </div>

        <div className="filter-item" style={{ width: '250px' }}>
          <FormControl size="small" fullWidth>
            <InputLabel id="demo-simple-select-outlined-label">Price</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={menu_text}
              style={{ color: 'rgba(0, 0, 0, 0.6)' }}
              label="Price"
              onClose={() => setMenuText('1')}
            >
              <MenuItem value="" style={{ display: 'flex', flexDirection: 'column' }}>
                <Slider
                  getAriaLabel={() => 'Price range'}
                  value={filterPrice}
                  min={0}
                  max={maxPrice}
                  valueLabelDisplay="off"
                  onChange={(event, value: any) => setFilterPrice(value)}
                  track="inverted"
                  classes={{
                    thumb: classes.thumb,
                    rail: classes.rail,
                    track: classes.track,
                    valueLabel: classes.valueLabel
                  }}
                />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    size="small"
                    disabled
                    value={filterPrice[0]}
                    type="number"
                    style={{ width: 'auto', maxWidth: '130px', paddingRight: '10px' }}
                  >
                    {' '}
                  </TextField>
                  to{' '}
                  <TextField
                    size="small"
                    disabled
                    value={filterPrice[1]}
                    type="number"
                    style={{ width: 'auto', maxWidth: '130px', paddingLeft: '10px' }}
                  >
                    {' '}
                  </TextField>
                </div>
              </MenuItem>
              <MenuItem
                value="1"
                style={{ display: 'none' }}
              >{`Price Range : ${filterPrice[0]} - ${filterPrice[1]}`}</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="filter-item">
          <Autocomplete
            classes={classes}
            size="small"
            getOptionLabel={(option: IListingProduct) => option.ext_prod_id || ''}
            id="combo-box-demo"
            options={products || []}
            renderInput={(params) => <TextField {...params} label="Seller Code" size="small" variant="outlined" />}
            style={{ width: 160 }}
            value={filterSelCode}
            onChange={(e, value) => setFilterSelCode(value)}
          />
        </div>

        <div className="filter-item">
          <Autocomplete
            size="small"
            classes={classes}
            getOptionLabel={(option: IListingProduct) => option.psn || ''}
            id="combo-box-demo"
            options={products || []}
            renderInput={(params) => <TextField {...params} label="PSN" size="small" variant="outlined" />}
            style={{ width: 160 }}
            value={filterPsn}
            onChange={(e, value) => setFilterPsn(value)}
          />
        </div>

        <div className="filter-item">
          <ActionButton
            label="Apply"
            onClick={() => {
              handleProductFilter()
            }}
          />
          <ActionButton
            label="Clear"
            onClick={() => {
              getSellerProducts('1')
              setFilterCategory(null)
              setFilterSku(null)
              setFilterBrand(null)
              setFilterErpCode(null)
              setFilterName(null)
              setFilterSelCode(null)
              setFilterPsn(null)
              setFilterMrp([0, maxMrp])
              setFilterPrice([0, maxPrice])
            }}
          />
        </div>
      </div>
      <table className="inventory-products-table allproducts-table">
        <thead>
          <tr>
            <th>
              Product
              <SortIcon name="name" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              Category
              <SortIcon name="category" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              Brand
              <SortIcon name="brand" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              Global SKU
              <SortIcon name="sku" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              Poorvika Product Code
              <SortIcon name="erp_item_code" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              Seller Product Code
              <SortIcon name="ext_prod_id" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              PSN
              <SortIcon name="psn" onClick={sortingFunctionalityHandler} />
            </th>
            <th>
              WholeSale Price
              <SortIcon name="wholesale_price" onClick={sortingFunctionalityHandler} />
            </th>

            <th>
              MRP
              <SortIcon name="mrp" onClick={sortingFunctionalityHandler} />
            </th>

            <th style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 9 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span> Status </span>
                  <SortIcon name="listing_status" onClick={sortingFunctionalityHandler} />
                </div>
              </div>
            </th>
            <th>Action</th>
          </tr>
        </thead>
        {product ? (
          <tbody>
            {product.map((item: IListingProduct) => {
              return (
                <tr key={item.erp_item_code}>
                  <td
                    onClick={() => {
                      setSelectedItem(item)
                      setDisplayModal(!displayModal)
                    }}
                  >
                    <div className="product-col">
                      <div className="pimg-wrap">
                        <img alt="product-img" className="product-img" src={item.image} />
                      </div>
                      <div className="pcontent-wrap">{item.name}</div>
                    </div>
                  </td>
                  <td>{item.category}</td>
                  <td>{item.brand}</td>
                  <td>{item.sku}</td>
                  <td>{item.erp_item_code}</td>
                  <td>{item.ext_prod_id}</td>
                  <td>{item.psn}</td>

                  <td>{item.wholesale_price}</td>
                  <td>{item.mrp}</td>

                  <td className="product-status-dropdown">
                    <ListingStatus
                      status={item.listing_status}
                      pim_code={item.pim_code}
                      statusProductHandler={statusProductHandler}
                    />
                  </td>
                  <td>
                    {item.listing_status!=="Blocked" && <Tooltip title="Edit">
                      <EditIcon className="edit-product" onClick={() => productEditConfirmationHandler(item)} />
                    </Tooltip>}
                  </td>
                </tr>
              )
            })}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td className="empty-data" colSpan={12}>
                No data to display
              </td>
            </tr>
          </tbody>
        )}
      </table>
      <div className="all-products-pagination">
        <Pagination
          className="all-products-pagination"
          count={pageCount}
          shape="rounded"
          variant="outlined"
          onChange={handleChange}
        />
      </div>

      <Dialog className="reject-products-dialog" open={RejectDialog}>
        <DialogTitle className="products-title" id="alert-dialog-title">
          Do you want to Reject this Product
        </DialogTitle>

        <InputLabelDownWithDropDown dropdown={IReason} name="Reason" text="Reason" onChange={(value) => setRejectReason(value as string)} />

        <DialogActions style={{ margin: '0 auto' }}>
          <ActionButton label="Cancel" type="button" varient="outlined" onClick={() => setRejectDialog(false)} />

          <ActionButton
            label="Add"
            type="submit"
            onClick={() => {
              setRejectDialog(false)
              statusAPIHandler('Rejected', rejectPimcode, rejectReason)
            }}
          />
        </DialogActions>
      </Dialog>
      <Dialog className="reject-products-dialog" open={BlockDialog}>
        <DialogTitle className="products-title" id="alert-dialog-title">
          Do you want to Block this Product
        </DialogTitle>

        <InputLabelDownWithDropDown dropdown={IReason} name="Reason" text="Reason" onChange={(value) => setRejectReason(value as string)} />

        <DialogActions style={{ margin: '0 auto' }}>
          <ActionButton label="Cancel" type="button" varient="outlined" onClick={() => setBlockDialog(false)} />

          <ActionButton
            label="Add"
            type="submit"
            onClick={() => {
              setBlockDialog(false)
              statusAPIHandler('Blocked', blockPimcode, rejectReason)
            }}
          />
        </DialogActions>
      </Dialog>
      <ProductDetailsSlider
        productDetails={selectedItem}
        displayModal={displayModal}
        handleClose={() => {
          setDisplayModal(!displayModal)
          getSellerProducts(1)
        }
        }
      />

      <Dialog open={showEditConfirmation}>
        <div className="edit-price-confirmation-dialog">
          <h1 className="dialog-heading">Edit Listed Product</h1>
          <div className="warning-message">
            <p>
              <strong>Warning: </strong> Editing listed product information will cause below effects
            </p>
          </div>
          <ul>
            <li>
              Product will be submitted for the <strong>re-approval</strong>
            </li>
            <li>
              Available stock count will be temporarily changed to <strong>Zero</strong>{' '}
            </li>
          </ul>
          <div className="flex flex-center">
            <div className="flex-50">
              <ActionButton onClick={() => setShowEditConfirmation(false)} label="Cancel" varient="outlined" />
            </div>
            <div className="flex-50">
              <ActionButton label="Proceed" onClick={editProductConfirmationHandler} />
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog className="add-products-dialog" open={showProductEditDialog}>
        <form onSubmit={handleSubmit(editProductPriceHandler)}>
          <div className="dialog-header edit-price-confirmation-dialog">
            <div className="product-code-wrap">
              <span className="product-code-header">Product code: </span>
              {editableProduct?.erp_item_code}
            </div>
            <h1 className="dialog-heading">Do you want to Edit this Product details?</h1>
          </div>
          <div className="dialog-content-wrap">
            <div className="left-content-dialog">
              <div className="pimg-wrap">
                <img alt={editableProduct?.name} className="product-img" src={editableProduct?.image} />
              </div>
              <div className="pcontent-wrap">{editableProduct?.name}</div>
            </div>
            <div>
              <InputField
                inputRef={register({
                  required: 'Please enter Reason'
                })}
                label="Seller Product Unique Code"
                name="ext_product_id"
                defaultValue={editableProduct?.ext_prod_id}
                style={{ margin: '5px' }}
                variant="outlined"
              />

              <InputField
                inputRef={register({
                  required: 'Please enter wholesale_price'
                })}
                defaultValue={editableProduct?.wholesale_price}
                label="WholeSale Price"
                name="wholesale_price"
                style={{ margin: '5px' }}
                variant="outlined"
              />

              <InputField
                inputRef={register({
                  required: 'Please enter MRP'
                })}
                label="MRP Price"
                name="mrp"
                defaultValue={editableProduct?.mrp}
                style={{ margin: '5px' }}
                variant="outlined"
              />

              <DialogActions className="dialog-action-btn-wrap" style={{ margin: '0 auto' }}>
                <ActionButton
                  label="Cancel"
                  type="button"
                  varient="outlined"
                  onClick={() => setShowProductEditDialog(false)}
                />

                <ActionButton label="Modify" type="submit" />
              </DialogActions>
            </div>
          </div>
        </form>
      </Dialog>
    </div>
  )
}
export default ALLProductTable
